/* oxlint-disable typescript/no-unsafe-return, typescript/no-unsafe-assignment, typescript/no-unsafe-member-access, typescript/no-unsafe-argument, typescript/no-unsafe-call -- hash fn walks arbitrary query-key structure typed as `any` */
export type QueryKey = readonly unknown[]

function isPlainObject(val: unknown): val is Record<string, unknown> {
  return typeof val === 'object' && val !== null && !Array.isArray(val)
}

export function hashQueryKey(queryKey: QueryKey): string {
  return JSON.stringify(queryKey, (_, val) =>
    isPlainObject(val)
      ? Object.keys(val)
          .toSorted()
          .reduce((result, key) => {
            if (key === 'tel') return result

            result[key] = val[key]
            return result
            // oxlint-disable-next-line typescript/no-explicit-any -- reduce accumulator type
          }, {} as any)
      : val,
  )
}
